import { APIClient, ApiQueryParams, DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { IGroup } from '@frontend/group/types';
import { IProduct } from '@frontend/product/types';

export class ProductOrderClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    /**
     * This function will return a list of products and categories that can be ordered by the user.
     * Parent Category id should be provided.
     *
     * Used for tree browsing.
     */
    public static async fetchCategoryOrderProducts(
        accountId: string,
        category_id: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>,
        withCredentials?: Token
    ): Promise<PaginatedResponse<IProduct | IGroup>> {
        return await this.apiPaginated<PaginatedResponse<IProduct | IGroup>, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/product-categories/${category_id}/order-categories`,
            queryParams,
            withCredentials
        );
    }

    /**
     * Will return a list of products and LEAF categories that can be ordered by the user.
     * Basically a fetch All for the user.
     */
    public static async fetchOrderProducts(
        queryParams?: ApiQueryParams<DefaultQueryParams>,
        withCredentials?: Token
    ): Promise<PaginatedResponse<IProduct | IGroup>> {
        return await this.apiPaginated<PaginatedResponse<IProduct | IGroup>, DefaultQueryParams>(
            `${this.endpoint}/order-products`,
            queryParams,
            withCredentials
        );
    }
}
